import React from 'react'
import { Box, Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { formatCurrency } from '../../../lib/intl-utils'
import Markdown from '../../../components/Markdown'
import SectionHeadline from '../../../components/SectionHeadline'
import CostsBreakdown from './CostsBreakdown'

const useStyles = makeStyles(theme => ({
  licencePlateNumber: {
    textTransform: 'uppercase'
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  divider: {
    margin: `.5em 0`,
    backgroundColor: theme.palette.primary.dark
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold'
  },
  heading: {
    fontSize: '1.25rem',
    marginBottom: 0
  },
  subHeading: {
    fontSize: '0.875rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2)
  }
}))

const calcPriceAdditionMaterial = (defects, vat, priceAdditionMaterial) => {
  const materialCostsSum = defects.filter(_ => _.ordered === true).map(_ => _.price.material / (1 + vat / 100)).reduce((a, b) => a + b, 0)
  return materialCostsSum * (priceAdditionMaterial.priceAdditionPercentage / 100) * (1 + vat / 100)
}

const calcPriceAdditionLabor = (defects, vat, priceAdditionLabor) => {
  const laborCostsSum = defects.filter(_ => _.ordered === true).map(_ => _.price.labor / (1 + vat / 100)).reduce((a, b) => a + b, 0)
  return laborCostsSum * (priceAdditionLabor.priceAdditionPercentage / 100) * (1 + vat / 100)
}

const Summary = ({
  orderNumber = '',
  licencePlateNumber = '',
  totalCosts = 0,
  vat,
  currency,
  defects,
  letter,
  pickupTime,
  priceAdditionMaterial,
  priceAdditionLabor
}) => {
  const classes = useStyles()
  return (
    <Box my={3}>
      <div>Auftragsnr.: {orderNumber}</div>
      <div>
        Kennzeichen:{' '}
        <span className={classes.licencePlateNumber}>
          {licencePlateNumber}
        </span>
        <Divider className={classes.divider} />
        <CostsBreakdown
          currency={currency}
          defects={defects.filter(_ => _.isPriceAddition !== true)}
        />
        {(priceAdditionLabor !== null && priceAdditionLabor !== undefined) && (
          <div className={classes.item}>
            <span>{priceAdditionLabor.name}</span>
            <strong>{formatCurrency(calcPriceAdditionLabor(defects, vat, priceAdditionLabor), currency)}</strong>
          </div>
        )}
        {(priceAdditionMaterial !== null && priceAdditionMaterial !== undefined) && (
          <div className={classes.item}>
            <span>{priceAdditionMaterial.name}</span>
            <strong>{formatCurrency(calcPriceAdditionMaterial(defects, vat, priceAdditionMaterial), currency)}</strong>
          </div>
        )}
        <div className={classes.total}>
          <span>Gesamtpreis (inkl. MwSt.)</span>
          {(priceAdditionMaterial !== undefined || priceAdditionLabor !== undefined) && (
            <span>{formatCurrency((totalCosts + calcPriceAdditionMaterial(defects, vat, priceAdditionMaterial) + calcPriceAdditionLabor(defects, vat, priceAdditionLabor)), currency)}</span>
          ) || (
              <span>{formatCurrency(totalCosts, currency)}</span>
            )}
        </div>
        <Divider className={classes.divider} />
        {pickupTime && (
          <div>
            <h2 className={classes.heading}>Voraussichtliche neue Abholzeit: {pickupTime}</h2>
            <div className={classes.subHeading}>Hinweis: Bei gebuchter Mobilität können sich die Kosten erhöhen.</div>
            <Divider className={classes.divider} />
          </div>
        )}
        <Markdown>{letter || ''}</Markdown>
        <Divider className={classes.divider} />
      </div>
    </Box>
  )
}

export default Summary
